export const formatQuantity = (qty) => {
    if (qty === undefined || qty === null) {
        return 0
    }
    let qtyFormat = qty
    if (typeof qty !== 'number')
        parseFloat((qtyFormat))
    let checkDecimals = qty.toString()
    if (checkDecimals.includes('.') && checkDecimals.split('.')[1].length > 3) {
        return parseFloat(parseFloat(qtyFormat).toFixed(3))
    } else {
        return parseFloat((qtyFormat))
    }
}

export const customSupplierFilter = (options, state) => {
    return options.filter(item =>
        (item.TIN && item.TIN.includes(state.inputValue)) ||
        (item.name && item.name.includes(state.inputValue)) ||
        (item.CIN && item.CIN.includes(state.inputValue))
    )
}

export function getAllCurrentTaxRates(rates) {
    let allRates = []
    for (let i = 0; i < rates.length; i++) {
        for (let j = 0; j < rates[i].taxRates.length; j++) {
            allRates.push(rates[i].taxRates[j])
        }
    }
    return allRates
}

export async function fetchBlobFromImgUrl(imageUrl) {
    const xhr = new XMLHttpRequest();

    xhr.responseType = 'blob';
    xhr.onload = (event) => {
        return (xhr.response)
    };
    xhr.open('GET', imageUrl);
    xhr.send();
}